import { ITypeAsset, ITypeAssetResponse } from '../types/typeAssets.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class TypeAssetsRepository {
  static async getTypeAssets(allTypeAssets: boolean = false) {
    try {
      const response = await $http.get('/typeAssets/select/all', { params: allTypeAssets ? { flag: 'all' } : {} });
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async getTypeAssetsProPaginated(params: Params = {}): Promise<ITypeAssetResponse> {
    try {
      let url = `/typeAssets/pro`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `${params.page ? '&' : '?'}search=${encodeURIComponent(params.search)}`;
      }
      if (params.deleted) {
        url += `${params.page || params.search ? '&' : '?'}deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async createTypeAsset(data: ITypeAsset): Promise<ITypeAsset> {
    try {
      const { data: { data: typeAsset } } = await $http.post('/typeAssets', data);
      return typeAsset;
    } catch (error) {
      throw Error;
    }
  }

  static async updateTypeAsset(data: ITypeAsset): Promise<ITypeAsset> {
    try {
      const response = await $http.patch(`/typeAssets/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async deleteTypeAsset(id: number): Promise<void> {
    try {
      const response = await $http.delete(`/typeAssets/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async restoreTypeAsset(id: number): Promise<ITypeAsset> {
    try {
      const response = await $http.patch(`/typeAssets/${id}/restore`, {});
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
}

export default TypeAssetsRepository;
